import script from "./CollectionAddEditPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./CollectionAddEditPopup.vue?vue&type=script&setup=true&lang=js"

import "./CollectionAddEditPopup.vue?vue&type=style&index=0&id=e9a5a636&lang=scss"

const __exports__ = script;

export default __exports__